import { GraphQLClient } from 'graphql-request';

const shopifyClient = new GraphQLClient(
  `https://${process.env.GATSBY_SHOPIFY_STORE_SUBDOMAIN}/api/2023-10/graphql.json`,
  {
    headers: {
      'X-Shopify-Storefront-Access-Token': process.env.GATSBY_STOREFRONT_KEY,
      'Content-Type': 'application/json',
    },
  }
);

export default shopifyClient;
